import { FormControl, MenuItem, FormHelperText } from '@mui/material';
import { FC, useMemo } from 'react';
import { useQuery } from 'react-query';
import { IDropdownResponse } from '../../models';
import { SMBSelect } from '../input';
import { getAdminLookupCountiesByStateAbbreviation } from '../../fetch/lookups';

interface ICountiesDropdownProps {
  value: string | number;
  handleChange: (val: string) => void;
  isDisabled?: boolean;
  setOptions?: (val: IDropdownResponse[]) => void;
  isRequired?: boolean;
  message?: string;
  hasError?: boolean;
  apiParams?: any;
}

export const CountiesDropdown: FC<ICountiesDropdownProps> = ({
  isDisabled,
  isRequired,
  value,
  handleChange,
  setOptions,
  message,
  hasError,
  apiParams
}) => {
  const { isLoading, data: countiesData } = useQuery<IDropdownResponse[], Error>(
    ['counties-data', apiParams?.stateAbbreviation],
    async () => await getAdminLookupCountiesByStateAbbreviation(apiParams?.stateAbbreviation),
    {
      notifyOnChangeProps: 'tracked',
      onSuccess: d => setOptions?.(d),
      enabled: apiParams?.stateAbbreviation?.trim() !== ''
    }
  );
  const counties = useMemo(() => countiesData ?? [], [countiesData]);
  return (
    <FormControl fullWidth variant="outlined" size="small" required={isRequired} error={hasError}>
      <SMBSelect
        disabled={isDisabled || isLoading}
        name={`county`}
        label={isLoading ? 'Loading...' : 'County'}
        id={`county`}
        value={value}
        variant="outlined"
        handleClear={() => handleChange('')}
        onChange={({ target: { value } }) => {
          handleChange(value as string);
        }}
        SelectProps={{
          MenuProps: {
            sx: {
              maxHeight: '30rem'
            }
          }
        }}
      >
        {!isLoading && counties && counties.length === 0 && (
          <MenuItem disabled>No counties available</MenuItem>
        )}
        {!isLoading &&
          counties &&
          counties.map((county, index) => {
            return (
              <MenuItem key={county.value} value={county.value}>
                {county.description}
              </MenuItem>
            );
          })}
      </SMBSelect>
      {message && <FormHelperText error>{message}</FormHelperText>}
    </FormControl>
  );
};
